module.exports = __webpack_public_path__ + "static/media/project_dino_a_1024.b95e0c97.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/project_dino_a_1024.png
// module id = 63
// module chunks = 0